import * as React from 'react';
import type { SVGProps } from 'react';

export const SvgGuideNavIconCart = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={73} height={72} viewBox="0 0 73 72" fill="none" {...props}>
    <circle cx={36.5} cy={36} r={35} fill="#FF001A" stroke="#FF001A" strokeWidth={2} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M45 44H30.725l-3.488-19.175a1 1 0 0 0-.974-.825H24M32 49a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M45 49a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M29.813 39h15.7a1.99 1.99 0 0 0 1.962-1.638L49 29H28"
    />
  </svg>
);
